import { styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const EnhanceAllButton = styled(SButton)({
  borderRadius: 120,
  maxHeight: 'max-content',
  fontWeight: 600,

  '&.Mui-disabled': {
    color: '#AFBAC6',
    '& svg path': {
      fill: '#AFBAC6'
    }
  }
});

export const ExportProductButton = styled(SButton)({
  borderRadius: 120,
  fontWeight: 600
});
